import { CreateReport17Form } from './create-report-17-form'

export const CreateReport17 = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <CreateReport17Form onCloseModal={onCloseModal} />
}
